// Module
var code = `<select ng-options="enum.value as enum.text for enum in enums" ng-change="onChange()"><option value="" selected="selected" disabled="disabled" hidden>Choose&hellip;</option></select>`;
// Exports
export default code;